const ko = {
    addMember: '멤버 추가',
    avatar: '아바타',
    phNumber: '휴대전화번호',
    permissions: '권한',
    isAdmin: '시스템 관리자',
    acntExists: '계정이 이미 존재합니다',
    addSuccess: '성공적으로 추가되었습니다',
    addFailed: '추가 실패',
    tips: '팁',
    confirmAction: '정말 원하시나요',
    disable: '비활성화',
    enable: '활성화',
    bascInfoUp: '기본 정보가 성공적으로 수정되었습니다',
    userPerSetSuc: '사용자 권한이 성공적으로 설정되었습니다',
    pwdChanged: '비밀번호가 성공적으로 변경되었습니다',
    mobileChangeSuc: '휴대전화 번호가 성공적으로 변경되었습니다',
    aginLogin: '다시 로그인해 주세요!',
    validaFailed: '검증 실패',
    pwd: '비밀번호',
    enterPwd: '비밀번호를 입력하세요',
    pwdMinLength: '비밀번호는 최소 6자 이상이어야 합니다',
    plConfirmPwd: '비밀번호를 확인해 주세요',
    confirmPwd: '비밀번호 확인',
    pwdDiff: '두 비밀번호가 일치하지 않습니다',
    reenterPwd: '비밀번호를 다시 확인해 주세요',
    memberDetails: '회원 세부 정보',
    basicInfo: '기본 정보',
    searchPrompt: '검색하려면 name1, name2, 휴대폰 번호를 입력하세요',
    sure: '확실히',
    viewDetails: '세부정보 보기',
    thisMember: '이 회원?',
    maxLengthTip: '콘텐츠가 최대 길이 제한을 초과했습니다! ',
    changeStatusSucc: '작업이 성공했습니다!',
    phNumberTip: '전화번호를 입력하세요',
    updateFail: '수정 실패',
    userDataNoExistTip: '사용자 데이터가 존재하지 않거나 사용자가 비활성화되었습니다',
    mobileEmpty: '휴대전화 번호는 비워둘 수 없습니다',
    userFetchFail: '사용자 정보를 얻지 못했습니다',
    name1: '이름1',
    name2: '이름2',
};

export default ko;